var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinusIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7456 28.999C39.1943 28.999 39.6246 29.1769 39.9419 29.4941C40.2591 29.8114 40.4379 30.2418 40.438 30.6904C40.438 31.1392 40.2592 31.5704 39.9419 31.8877C39.6246 32.2049 39.1943 32.3828 38.7456 32.3828H21.2319C20.7833 32.3827 20.3529 32.2049 20.0356 31.8877C19.7183 31.5704 19.5405 31.1392 19.5405 30.6904C19.5406 30.2418 19.7184 29.8114 20.0356 29.4941C20.3529 29.1769 20.7833 28.9991 21.2319 28.999H38.7456Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.465407
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusIcon);
export default __webpack_public_path__ + "static/media/minusIcon.0f029fa04aff1d38392e32f2eced1012.svg";
export { ForwardRef as ReactComponent };